<template>
    <tr class="h-auto" :class="{'bg-gray-50' : isArchived}">
        <td class="px-4 py-2 text-sm font-medium" :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            <div class="flex items-center gap-2 whitespace-nowrap">
                <span :title="inspection.date | datetime">{{ inspection.date | date }}</span>
            </div>
            <span class="invisible block">Placeholder</span>
        </td>
        <td class="group whitespace-nowrap py-2 px-3 text-sm font-normal hidden md:table-cell" :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            <div class="hidden md:table-cell">
                <div class="flex items-center flex-nowrap justify-start gap-2 font-normal mb-0.5">
                    {{ inspection.type }} Inspection
                </div>
                <div class="hidden md:table-cell">
                    <span
                        class="relative inline-flex items-center px-2 py-0 rounded bg-white text-sm font-medium transition duration-300"
                        :class="getStatusBadgeClasses(inspection.status)">
                        {{ isArchived ? "archived" : inspection.status }}
                    </span>
                </div>
            </div>
        </td>
        <td class="whitespace-nowrap px-3 py-2 text-sm font-normal">
            <div :class="[isArchived ? 'text-gray-400' : 'text-indigo-600 font-normal']">
                {{ inspection.tenant_name ? inspection.tenant_name : "No Tenant" }}
            </div>
            <div :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
                <template v-if="currentTailwindBreakpoint >= 2">
                    {{ inspection.inspector_name ? inspection.inspector_name : "-" }}
                </template>
                <template v-else>
                    {{ inspection.type }} Inspection
                </template>
            </div>
        </td>
        <td class="flex items-center justify-end px-3 py-4 hidden md:table-cell md:text-right md:px-4">
            <button class="font-medium"
                    :class="[isArchived ? 'text-gray-400 hover:text-gray-300' : 'text-indigo-600 hover:text-indigo-500']"
                    @click.prevent="openInspectionInNewTab(inspection.id)">View
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    name: "inspection-row-in-list-for-asset",
    props: ["inspection"],
    computed: {
        isArchived () {
            return this.inspection.archived_at !== null;
        },
        isHovered () {
            return false;
        },
    },
    methods: {
        openInspectionInNewTab (inspectionId) {
            window.open(`/inspections/${inspectionId}`, "_blank");
        },
        getStatusBadgeClasses (status) {
            if (this.isArchived) {
                return "bg-gray-100 text-gray-400";
            }

            switch (status) {
                case "uploaded":
                    return "bg-yellow-100 text-yellow-600";
                case "completed":
                    return "bg-green-100 text-green-600";
                default:
                    return "bg-indigo-100 text-indigo-600";
            }
        },
    }
};
</script>

<style scoped>

</style>
